var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":"","dialog":""},on:{"click":function($event){return _vm.imprimir_modal()}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-print")])],1)]}}])},[_c('span',[_vm._v("Imprimir")])])}
var staticRenderFns = []

export { render, staticRenderFns }